import type { PropsWithChildren as PWC, ReactElement } from 'react';

import {
    BaseCard,
    Container,
    Flex,
    Stack,
    Text,
} from '@myphx-engineering/phx-design-system';

import type { PathwayTerms } from '../../../configuration/shared';

import classes from './program-savings-card.module.css';

export type ProgramSavingsCardProps = {
    'data-testid'?: string;
    patientInfo: ReactElement;
    savingsCard: NonNullable<PathwayTerms['savingsCard']>;
};

export const ProgramSavingsCard = ({
    'data-testid': dataTestId,
    patientInfo,
    savingsCard,
    children,
}: PWC<ProgramSavingsCardProps>) => {
    return (
        <Container className={classes.container} type="inline-size">
            <BaseCard
                withBorder
                p={0}
                variant="filled"
                radius="sm"
                className={classes.card}
                data-testid={dataTestId}
            >
                <Stack gap={0}>
                    <Flex gap="sm" align="center" justify="space-between">
                        <Flex
                            bg="primary"
                            align="center"
                            className={classes.logo}
                        >
                            <img
                                src="/static/img/lilly-logo-neg.png"
                                alt="LillyDirect"
                            />
                        </Flex>
                        <Text className={classes.cardType} p="0 1rem">
                            {savingsCard.type}
                        </Text>
                    </Flex>
                    <Stack
                        classNames={{ root: classes.contentWrapper }}
                        gap="sm"
                        py="lg"
                    >
                        <Stack classNames={{ root: classes.cardInfo }}>
                            <Text className={classes.cardTitle}>
                                {savingsCard.name}
                            </Text>
                            {patientInfo}
                        </Stack>
                        {children}
                    </Stack>
                </Stack>
            </BaseCard>
        </Container>
    );
};
